const parseHtml = (html) => {
  const txt = document.createElement("div")
  txt.innerHTML = html
  return txt.textContent || txt.innerText || txt.value || ""
}

module.exports = parseHtml
